import { Avatar, Box, ButtonBase, Typography, useTheme } from "@mui/material";
import React from "react";
import { userDisplayName } from "../../pages/events/components/EventFunctions";
import { BCPUser } from "../icons/bcp/BCPIcons";

export default function UserCardSmall(props) {
  const { user, buttonSx } = props;

  const theme = useTheme();
  const mode = theme.palette.mode;

  return (
    <ButtonBase
      href={`/user/${user?.id}`}
      sx={{
        backgroundColor:
          mode === "dark" ? "background.tertiary" : "background.secondary",
        borderRadius: 1,
        pl: 2,
        pr: 2,
        pt: 1,
        pb: 1,
        width: "100%",
        height: "100%",
        border: `1px solid ${theme.palette.divider}`,
        ...buttonSx,
      }}
      focusRipple
    >
      {(user?.name || user?.firstName || user?.lastName) && (
        <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
          {user?.profileImageUrl ? (
            <Avatar
              alt={user?.name}
              src={user?.profileImageUrl || user?.avatarUrl}
              sx={{
                width: 28,
                height: 28,
                p: 1.5,
              }}
            />
          ) : (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                backgroundColor:
                  mode === "dark"
                    ? "background.tertiary"
                    : "background.secondary",
                border: `1px solid ${theme.palette.divider}`,
                p: 1.5,
                mr: 1,
              }}
            >
              <BCPUser />
            </Box>
          )}
          <Box>
            <Typography sx={{ fontWeight: 700 }}>
              {user?.name
                ? user.name.trim()
                : userDisplayName(user?.firstName, user?.lastName).trim()}
            </Typography>
          </Box>
        </Box>
      )}
    </ButtonBase>
  );
}
